
setAnnounceSplide();
document.addEventListener('shopify:section:load', function (event) {
  setAnnounceSplide()
});

function setAnnounceSplide(){
  if (document.getElementById("announceSplide")) {
    const announceSplide = new Splide("#announceSplide", {
      type: 'loop',
      speed: 800,
      drag: false,
      focus: 1,
      perPage: 100,
      clones: 20,
      gap: 80,
      autoWidth: true,
      pauseOnHover: false,
      autoScroll: {
        speed: 0.5,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
    });
    announceSplide.mount(window.splide.Extensions);
  }
}
